"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FIELD_CONSTANTS = require("./mappings/FIELD_CONSTANTS");

var _default = {
  /**
   * @return {boolean}
   */
  validate: function V(schema, data) {
    V.errors = [];
    var mkto = schema.mkto;
    var UTMMediumField = mkto === "legacy" ? 'UTMMedium' : 'UTM_Medium__c';
    var UTMMedium = data[UTMMediumField];
    var fieldValuMap = (0, _FIELD_CONSTANTS.FIELD_VALUE_MAP)(mkto); // send no error when there is no UTMMedium field in the record

    if (!UTMMedium) return true; // If the UTMMedium starts with default then pass it through

    if (UTMMedium.startsWith('default')) return true;
    var utmMediumValues = fieldValuMap[UTMMediumField].join('|').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
    utmMediumValues = '^$|^(' + utmMediumValues + ')$';
    var regex = new RegExp(utmMediumValues, 'i');

    if (!regex.test(UTMMedium)) {
      V.errors.push({
        keyword: "UTMMedium",
        message: "'".concat(UTMMedium, "' is not a valid '").concat(UTMMediumField, "'.")
      });
      return false;
    }

    return true;
  },
  errors: true
};
exports.default = _default;
//# sourceMappingURL=UTMMediumKeyword.js.map